import * as React from "react";
const SvgMinus = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 19 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2.96875 9.5H16.0312", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "square" }));
export default SvgMinus;
